import {
  DOCTOR_WITH_CUSTOMER_SUCCESS,
  DOCTOR_WITH_CUSTOMER_FAIL,
  SET_MESSAGE,
  DOCTOR_WITH_CUSTOMER_PENDING,
} from "../types";
import UserService from "../../services/user.service";
import { toast } from "react-toastify";

export const getDoctorsWithCustomerRank = (id) => async (dispatch) => {
  dispatch({
    type: DOCTOR_WITH_CUSTOMER_PENDING,
    payload: { doctors: "isLoading" },
  });
  return await UserService.getDoctorsWithCustomer(id)
    .then(
      (data) => {
        console.log(data);
        data.data.status
          ? dispatch({
              type: DOCTOR_WITH_CUSTOMER_SUCCESS,
              payload: { doctors: data.data.result },
            })
          : dispatch({
              type: DOCTOR_WITH_CUSTOMER_FAIL,
            });
        return Promise.resolve();
      },
      (error) => {
        console.log("error......", error);
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        dispatch({
          type: DOCTOR_WITH_CUSTOMER_FAIL,
        });

        dispatch({
          type: SET_MESSAGE,
          payload: message,
        });

        return Promise.reject();
      }
    )
    .catch((error) => {
      console.log(error);
    });
};
